export const isAdmin = (user) => Boolean(user?.is_staff || user?.is_superuser);
